import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { useCartUpdate } from "@faire/retailer-visitor-shared/hooks/cart/useCartUpdate";
import { useCollectionDisplayPromo } from "@faire/retailer-visitor-shared/views/product-based-collection/useCollectionDisplayPromo";
import { useCallback } from "react";
export var useCartUpdateWithDisplayPromo = function(collection) {
    var fetchDisplayPromoProgress = useCollectionDisplayPromo(collection).fetchDisplayPromoProgress;
    var updateCartItems = useCartUpdate().updateCartItems;
    var updateItems = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(items, options, brandCarts) {
            var e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            updateCartItems({
                                items: items,
                                allowEmptyItems: true,
                                brand_carts: brandCarts,
                                upltParams: options.upltParams
                            })
                        ];
                    case 1:
                        _state.sent();
                        if (collection) {
                            fetchDisplayPromoProgress();
                        }
                        return [
                            2
                        ];
                    case 2:
                        e = _state.sent();
                        return [
                            2
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(items, options, brandCarts) {
            return _ref.apply(this, arguments);
        };
    }(), [
        updateCartItems,
        fetchDisplayPromoProgress,
        collection
    ]);
    return {
        updateItems: updateItems
    };
};
